export default __webpack_public_path__ + "static/video-11-aa972d25a196dcd153ee48f4c94d1922.png";